module.exports = __webpack_public_path__ + "img/daily_necessities_bath.231823ba.jpg";